/**
 * Wave L-1 (PLAN-CITY2 §6, Loot 2.0): the rarity ladder shared by every loot
 * system — drop tables (`economy/drops.ts`), cosmetics (`economy/wardrobe.ts`),
 * and the rare-drop juice (L-4, `loot/pickup.ts`'s per-rarity glow/beam).
 * COMMON/UNCOMMON stay per-kill economy (coins/scrap, weapon parts); RARE is
 * folded into a bigger parts payout rather than a fabricated weapon-unlock
 * system (see `economy/drops.ts`'s own comment on why); EPIC/LEGENDARY are
 * cosmetics (`economy/wardrobe.ts`).
 */
export type Rarity = 'common' | 'uncommon' | 'rare' | 'epic' | 'legendary';

export const RARITY_ORDER: readonly Rarity[] = ['common', 'uncommon', 'rare', 'epic', 'legendary'];

/** This project's own gold accent family (Classic TOKENS.taxiGold / ai/boss.ts's GOLD) reused for legendary, for visual-language consistency across both games. */
export const RARITY_COLOR: Record<Rarity, number> = {
  common: 0xd8dce2,
  uncommon: 0x6fe37a,
  rare: 0x59a7ff,
  epic: 0xb15cff,
  legendary: 0xffc94a,
};

export const RARITY_LABEL: Record<Rarity, string> = {
  common: 'COMMON',
  uncommon: 'UNCOMMON',
  rare: 'RARE',
  epic: 'EPIC',
  legendary: 'LEGENDARY',
};
